export enum IAnalyticsEventEnum {
  Id = 'AnalyticsEvent.id',
  AccountId = 'AnalyticsEvent.accountid',
  UserId = 'AnalyticsEvent.userid',
  Count = 'AnalyticsEvent.count',
  TotalDuration = 'AnalyticsEvent.totalDuration',
  MaxDuration = 'AnalyticsEvent.maxDuration',
  UserCount = 'AnalyticsEvent.userCount',
  Duration = 'AnalyticsEvent.duration',
  CreatedAt = 'AnalyticsEvent.createdat',
  UpdatedAt = 'AnalyticsEvent.updatedat',
  CreatedBy = 'AnalyticsEvent.createdby',
  UpdatedBy = 'AnalyticsEvent.updatedby',
  DeletedAt = 'AnalyticsEvent.deletedat',
  DeletedBy = 'AnalyticsEvent.deletedby',
  TeamId = 'AnalyticsEvent.teamid',
  EventType = 'AnalyticsEvent.eventtype',
  AppId = 'AnalyticsEvent.appid',
  SubscriptionId = 'AnalyticsEvent.subscriptionid',
  StartTime = 'AnalyticsEvent.starttime',
  LocalStartTime = 'AnalyticsEvent.localstarttime',
  EndTime = 'AnalyticsEvent.endtime',
  ExternalId = 'AnalyticsEvent.externalid',
  Title = 'AnalyticsEvent.title',
  Recurring = 'AnalyticsEvent.recurring',
  AttendeeCount = 'AnalyticsEvent.attendeecount',
  LocalStartDate = 'AnalyticsEvent.localstartdate',
  WeekCount = 'AnalyticsEvent.weekCount',
  DayCount = 'AnalyticsEvent.dayCount',
}
